import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "originSelect",
    "arrivalSelect",
    "passengerSelect",
    "dateSelect",
    "timeSelect",
    "priceDisplay",
    "passengerCountDisplay",
    "originCityDisplay",
    "arrivalCityDisplay",
    "dateDisplay",
    "timeDisplay",
    "taxiRideForm",
    "summaryDiv",
    "contactForm",
    "weekDay",
    "holidayNight",
    "contactTaxiRideId",
    "contactArrivalCityName",
    "contactPassengersCount",
    "contactPickupDatetime",
    "flightNumberFieldset",
    "flightNumberInput",
  ]

  static values = {
    destinationCitiesUrl: String,
    arrivalCityNamePreselected: String
  }

  connect () {
    this.updateDestinationCities()
    this.toggleFlightNumberFieldset()
  }

  updateDestinationCities () {
    if (this.originSelectTarget.value === "") return

    const selectedCityId = this.originSelectTarget.value

    const url = this.destinationCitiesUrlValue.replace(":id", selectedCityId);

    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.arrivalSelectTarget.innerHTML = `<option value=''>${I18n.arrival_city}</option>`
        data.forEach(city => {
          const option = document.createElement("option")
          option.value = city.name
          option.textContent = city.name
          this.arrivalSelectTarget.appendChild(option)
        })
        if (this.arrivalCityNamePreselectedValue) {
          this.arrivalSelectTarget.value = this.arrivalCityNamePreselectedValue
          this.toggleFlightNumberFieldset()
          this.arrivalCityNamePreselectedValue = null
        }
      })
      .catch((error) => {
        console.error("Error fetching destination cities:", error)
      })
  }

  toggleContactForm () {
    this.contactFormTarget.classList.toggle("hidden")
  }

  #formatDateToLocale (dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number)
    const localizedDate = new Date(year, month - 1, day)
    const locale = document.documentElement.lang || 'fr'
    const options = { year: 'numeric', month: 'long', day: 'numeric' }

    return localizedDate.toLocaleDateString(locale, options)
  }

  #toggleTimeOfDay (time) {
    if (time === "day") {
      this.weekDayTarget.classList.remove("hidden")
      this.holidayNightTarget.classList.add("hidden")
    } else {
      this.weekDayTarget.classList.add("hidden")
      this.holidayNightTarget.classList.remove("hidden")
    }
  }

  calculatePrice () {
    if (!this.taxiRideFormTarget.reportValidity()) return

    const originCityId = this.originSelectTarget.value
    const originCityName = this.originSelectTarget.selectedOptions[0].textContent
    const arrivalCityName = this.arrivalSelectTarget.value
    const date = this.dateSelectTarget.value
    const time = this.timeSelectTarget.value
    const passengers = parseInt(this.passengerSelectTarget.value, 10)

    fetch(`${this.taxiRideFormTarget.action}?origin_city_id=${originCityId}&arrival_city_name=${arrivalCityName}&date=${date}&time=${time}&passengers=${passengers}`)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          alert(data.error)
          return
        }
        if (data.price == 0) {
          this.priceDisplayTarget.textContent = I18n.contact_us
        } else {
          this.priceDisplayTarget.textContent = `${data.price.toString().replace(/\.0$/, '')} €`
          this.passengerCountDisplayTarget.textContent = passengers
          this.originCityDisplayTarget.textContent = originCityName
          this.arrivalCityDisplayTarget.textContent = arrivalCityName
          this.dateDisplayTarget.textContent = this.#formatDateToLocale(date)
          this.timeDisplayTarget.textContent = ` ${time}`
          this.#toggleTimeOfDay(data.time_of_day)

          this.summaryDivTarget.classList.remove("hidden")
        }
      })
      .catch((error) => {
        console.error("Error calculating price:", error)
      })
  }

  populateContactFormFields () {
    const taxiRideId = this.originSelectTarget.value
    const arrivalCity = this.arrivalSelectTarget.value
    const passengers = this.passengerSelectTarget.value
    const date = this.dateSelectTarget.value
    const time = this.timeSelectTarget.value

    const datetime = `${date} ${time}`

    this.contactTaxiRideIdTarget.value = taxiRideId
    this.contactArrivalCityNameTarget.value = arrivalCity
    this.contactPassengersCountTarget.value = passengers
    this.contactPickupDatetimeTarget.value = datetime
  }

  toggleFlightNumberFieldset() {
    if (!this.hasFlightNumberFieldsetTarget || !this.hasFlightNumberInputTarget) return

    const origin = this.originSelectTarget.options[this.originSelectTarget.selectedIndex].text.toLowerCase()
    const arrival = this.arrivalSelectTarget.value.toLowerCase()

    const containsAirport = /aeroport|aéroport|airport/.test(origin) || /aeroport|aéroport|airport/.test(arrival)

    const disabled = containsAirport

    this.flightNumberFieldsetTarget.hidden = !disabled
    this.flightNumberInputTarget.disabled = !disabled
    this.flightNumberInputTarget.required = disabled
  }
}
